__turbopack_context__.v({
  "className": "vazirmatn_2085d1ff-module__iyPysW__className",
});
